import turfQualityApi, {
  IUpdateTurfQualityPayload,
} from '@/api/config/turfQualityApi'
import { queryKeys } from '@/constant/common'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function updateTurfQuality(
  payload: IUpdateTurfQualityPayload,
): Promise<void> {
  await turfQualityApi.update(payload)
}

function useEditTurfQuality() {
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()
  const { t } = useTranslation()

  return useMutation(
    (payload: IUpdateTurfQualityPayload) => updateTurfQuality(payload),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([queryKeys.turfQuality])
        toast.success(t('editTurfQualitySuccess'))
        closeSidebar()
      },
      onError: (error: any) => {
        toast.error(error?.message)
      },
    },
  )
}

export default useEditTurfQuality
